
<template>
  <div id="page-data-view">


    <vs-alert color="danger" title="Data Not Found" :active.sync="data_not_found">
      <span>Data record with id: {{ $route.params.viewId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'app-portfolio-list'}" class="text-inherit underline">All Data</router-link>
      </span>
    </vs-alert>

    <div id="view-data" v-if="view_data">

      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-base">
          <vx-card title="Admin" class="mb-base">
            <agGridPortfolioManagersAdmin></agGridPortfolioManagersAdmin>
          </vx-card>
        </div>

        <div class="vx-col w-full md:w-1/2 mb-base">
          <vx-card title="Super Admin" class="mb-base">
            <agGridPortfolioManagers></agGridPortfolioManagers>
          </vx-card>
        </div>

        <!-- <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Property Managers" class="mb-base">
            <agGridPropertyManager></agGridPropertyManager>
          </vx-card>
        </div> -->
      </div>

      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-base">
          <vx-card title="Approver" class="mb-base">
            <agGridApprover></agGridApprover>
          </vx-card>
        </div>
      </div>
      
      <!-- <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Properties" class="mb-base">
            <agGridProperties></agGridProperties>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Contacts" class="mb-base">
            <agGridContacts></agGridContacts>
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Staff" class="mb-base">
            <agGridStaff></agGridStaff>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Folder Categories" class="mb-base">
            <agGridFolderCategories></agGridFolderCategories>
          </vx-card>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>
import agGridProperties from './agGrid-properties/agGrid.vue'
import agGridContacts from './agGrid-contacts/agGrid.vue'
import agGridFolderCategories from './agGrid-folderCategories/agGrid.vue'
// import agGridPortfolioManagers from './agGrid-portfolioManagers/agGrid.vue'
import agGridStaff from './agGrid-staff/agGrid.vue'
import agGridPropertyManager from './agGrid-propertyManager/agGrid.vue'
import agGridPortfolioManagers from '@/views/pages/dashboard/agGrid-portfolioManagers/agGrid.vue'
import agGridPortfolioManagersAdmin from '@/views/pages/dashboard/agGrid-portfolioManagersAdmin/agGrid.vue'
import agGridApprover from '@/views/pages/dashboard/agGrid-approvers/agGrid.vue'

import axios from '@/axios'
import mainHelper from '@/mainHelper' //crud

export default {
  components: {
    agGridProperties,
    agGridContacts,
    agGridFolderCategories,
    agGridPortfolioManagers,
    agGridPortfolioManagersAdmin,
    agGridStaff,
    agGridPropertyManager,
    agGridApprover,
  },
  data () {
    const token = localStorage.usertoken
    return {
      // crud
      showL: false,
      showC: false,
      showR: false,
      showU: false,
      showD: false,

      token: token,
      
      //portfolio
      view_data: {
        name: '',
        notes: '',
        address: '',
        phone: ''
      },
      data_not_found: false
    }
  },
  computed: {
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.view_data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.post(`/portfolio/delete/${viewId}`, {
              token: this.token
            })
            .then(res => {        
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
              } else {
                this.$router.push({name:'app-portfolio-list'})
                this.showDeleteSuccess()
              }

            })
            .catch(err => {              
              reject(err)
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.data_local = res[0]
        })
      })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Data Deleted',
        text: 'The selected data was successfully deleted'
      })
    },
    loadData () {
      const viewId = this.$route.params.viewId
      var d = new Promise(async(resolve, reject)  => {
        try {    
          await axios.get(`/portfolio/view/${viewId}`, {
              headers: { 'Authorization': this.token }
            })
            .then(res => {     
              if(res['data'] == 'access_denied' || res['data'] == '') {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Error loading',
                  text: 'Something went wrong'
                })
                // this.$router.push({name:'app-portfolio-list'})
              } else {
                resolve(res['data'])
              }

              this.$vs.loading.close()
            })
            .catch(err => {
              this.data_not_found = true
              this.$vs.loading.close()
            }) 
        } catch(err) {
          reject(err.toString('utf8'));
        }      

        d.then((res) => {
          this.view_data = res[0]
        })
      })
    }
  },
  async created () {
    // crud
    this.showL = await mainHelper.cansee('management-list', 'list')
    this.showC = await mainHelper.cansee('management-create', 'create')
    this.showR = await mainHelper.cansee('management-read', 'read')
    this.showU = await mainHelper.cansee('management-update', 'update')
    this.showD = await mainHelper.cansee('management-delete', 'delete')

    if (!this.showL) {
      this.$vs.notify({
        color: 'danger',
        title: 'Loading Page',
        text: 'You are not authorized to view this page.'
      })
      this.$router.push('/dashboard/analytics')
    }

  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-data-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

.avatar-img {
  position: relative;
  width: 230px;
  overflow: hidden;
  padding-top: 230px;
}

.avatar-img img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
}

</style>
